export enum ProfKindCodesEnum {
  OP = 'OP',
  PP = 'PP',
}
